import Home from "./components/Home";
import About from "./components/About";
import Video from "./components/Video";
import Contact from "./components/Contact";
import BioPage from "./components/BioPage";
import Calendar from "./components/Calendar";
import YachtRockBandPage from "./components/YachtRockBandPage";
import EventPage from "./components/EventPage";
import BlogPage from "./components/BlogPage";
import EPK from "./components/EPK";
import EPKBranded from "./components/EPKBranded";
import BlogPostDetail from "./components/BlogPostDetail";
import PrivacyPolicy from "./components/privacy-policy";
import ClientPortal from "./components/ClientPortal";
import DataDeletion from "./components/DataDeletion";
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import PrivateRoute from "./components/PrivateRoute";
import ThankYou from './components/sub-components/thank-you';

import AdminPage from "./components/admin/AdminPage";
import BlogUpdateForm from "./components/admin/BlogUpdateForm";
import Setlist from "./components/admin/Setlist";
import GigsTable from "./components/admin/GigsTable";
import ClientsTable from "./components/admin/ClientsTable";
import CalendarUpdate from "./components/admin/CalendarUpdate";

export const AppRoutes = (isAuthenticated, setIsAuthenticated) => {

    /* ===============================
       Routes WITH Layout
    =============================== */
    const withLayout = [
        { index: true, element: <Home /> },
        { path: "/About", element: <About /> },
        { path: "/Video", element: <Video /> },
        { path: "/Calendar", element: <Calendar /> },
        { path: "/eventpage/:eventId", element: <EventPage /> },
        { path: "/Contact", element: <Contact /> },
        { path: "/thank-you", element: <ThankYou /> },
        { path: "/BlogPage", element: <BlogPage /> },
        { path: "/BlogPage/:slug", element: <BlogPostDetail /> },
        { path: "/PrivacyPolicy", element: <PrivacyPolicy /> },
        { path: "/DataDeletion", element: <DataDeletion /> },
        { path: "/BioPage", element: <BioPage /> },
        { path: "/yacht-rock-band", element: <YachtRockBandPage /> },
    ];

    /* ===============================
       Standalone Routes (NO Layout)
    =============================== */
    const standalone = [
        // Private page for a booked client; the code in the link is their key (no login)
        { path: "/portal/:token", element: <ClientPortal /> },

        { path: "/EPK", element: <EPK /> },
        { path: "/EPKBranded", element: <EPKBranded /> },

        {
            path: "/LoginPage",
            element: <LoginPage setIsAuthenticated={setIsAuthenticated} />,
        },

        // Only a logged-in admin can add another admin account
        {
            path: "/RegisterPage",
            element: (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                    <RegisterPage />
                </PrivateRoute>
            ),
        },

        /* ===== ADMIN ROUTES ===== */

        {
            path: "/admin",
            element: (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                    <AdminPage setIsAuthenticated={setIsAuthenticated} />
                </PrivateRoute>
            ),
        },

        {
            path: "/admin/new",
            element: (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                    <BlogUpdateForm setIsAuthenticated={setIsAuthenticated} />
                </PrivateRoute>
            ),
        },

        {
            path: "/admin/:id",
            element: (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                    <BlogUpdateForm setIsAuthenticated={setIsAuthenticated} />
                </PrivateRoute>
            ),
        },

        {
            path: "/admin/setlist",
            element: (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                    <Setlist setIsAuthenticated={setIsAuthenticated} />
                </PrivateRoute>
            ),
        },

        {
            path: "/admin/gigs",
            element: (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                    <GigsTable setIsAuthenticated={setIsAuthenticated} />
                </PrivateRoute>
            ),
        },

        {
            path: "/admin/clients",
            element: (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                    <ClientsTable setIsAuthenticated={setIsAuthenticated} />
                </PrivateRoute>
            ),
        },

        {
            path: "/admin/calendar-update",
            element: (
                <PrivateRoute isAuthenticated={isAuthenticated}>
                    <CalendarUpdate setIsAuthenticated={setIsAuthenticated} />
                </PrivateRoute>
            ),
        },
    ];

    return { withLayout, standalone };
};

export default AppRoutes;
